import ButtonsHeader from "@/app/components/common/ButtonsHeader";
import { footerBg3Style } from "@/assets";

export default function ProfileSkeleton() {
  return (
    <>
      <ButtonsHeader heading="Profile" />
      <div className="flex items-center justify-start gap-4 px-4">
        <div className="h-25 w-25 animate-pulse rounded-full bg-[#F0E0C7]/60" />
        <div className="space-y-2">
          <div className="h-6 w-40 animate-pulse rounded bg-[#F0E0C7]/60" />
          <div className="h-5 w-28 animate-pulse rounded bg-[#F0E0C7]/60" />
        </div>
      </div>
      <div
        className="mt-4 min-h-[calc(100vh-13.5rem)] rounded-t-3xl bg-white p-6 pb-10"
        style={footerBg3Style}
      >
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={`profile-menu-${index}`}
            className="mb-4 flex items-center justify-between border-b border-b-gray-100 pb-4"
          >
            <div className="flex items-center gap-4">
              <div className="h-6 w-6 animate-pulse rounded bg-[#F0E0C7]/60" />
              <div className="h-4 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
            </div>
            <div className="h-4 w-4 animate-pulse rounded bg-[#F0E0C7]/60" />
          </div>
        ))}
      </div>
    </>
  );
}
